import { render, staticRenderFns } from "./JoinManagement.vue?vue&type=template&id=3b061dc2&scoped=true&"
import script from "./JoinManagement.vue?vue&type=script&lang=js&"
export * from "./JoinManagement.vue?vue&type=script&lang=js&"
import style0 from "./JoinManagement.vue?vue&type=style&index=0&id=3b061dc2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b061dc2",
  null
  
)

export default component.exports